import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/BrickCalculator/brickCalculator.container"
    ).then((module) => ({ default: module.BrickCalculator }))
);
